if (!customElements.get('birthday-video-form')) {
  customElements.define(
    'birthday-video-form',
    class BirthdayVideoForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.panels = this.querySelectorAll('.bv-wizard__panel');
        this.stepTabs = this.querySelectorAll('[data-step-tab]');

        this.nameInput = this.querySelector('[name="properties[Child\'s Name]"]');
        this.monthSelect = this.querySelector('.js-birth-month');
        this.daySelect = this.querySelector('.js-birth-day');
        this.yearSelect = this.querySelector('.js-birth-year');
        this.celebrationDateInput = this.querySelector('.js-celebration-date');
        this.birthdateValueInput = this.querySelector('.js-birthdate-value');
        this.turnsValueInput = this.querySelector('.js-turns-value');
        this.ageValueEl = this.querySelector('.js-age-value');
        this.celebrationCard = this.querySelector('.js-celebration-card');
        this.genderButtons = this.querySelectorAll('.js-gender-btn');
        this.genderValueInput = this.querySelector('.js-gender-value');

        this.photoInput = this.querySelector('.js-photo-input');
        this.photoValueInput = this.querySelector('.js-photo-value');
        this.photoPreview = this.querySelector('.js-photo-preview');
        this.dropzonePlaceholder = this.querySelector('.js-dropzone-placeholder');

        this.languageButtons = this.querySelectorAll('.js-language-btn');
        this.languageValueInput = this.querySelector('.js-language-value');
        this.langNameEls = this.querySelectorAll('.js-lang-name');

        this.reviewAvatar = this.querySelector('.js-review-avatar');
        this.reviewName = this.querySelector('.js-review-name');
        this.reviewAge = this.querySelector('.js-review-age');
        this.reviewLangBadge = this.querySelector('.js-review-lang-badge');
        this.reviewNameField = this.querySelector('.js-review-name-field');
        this.reviewBirthdate = this.querySelector('.js-review-birthdate');
        this.reviewCelebration = this.querySelector('.js-review-celebration');
        this.reviewLanguage = this.querySelector('.js-review-language');
        this.reviewPhoto = this.querySelector('.js-review-photo');
        this.reviewDeliveryDate = this.querySelector('.js-review-delivery-date');

        this.errorMessage = this.querySelector('.js-error');
        this.submitButton = this.querySelector('.birthday-video-form__submit');
        this.spinner = this.submitButton ? this.submitButton.querySelector('.loading__spinner') : null;

        this.currentAge = 1;

        [this.monthSelect, this.daySelect, this.yearSelect].forEach((el) =>
          el.addEventListener('change', this.onBirthdateChange.bind(this))
        );
        this.genderButtons.forEach((btn) => btn.addEventListener('click', () => this.selectGender(btn)));
        this.languageButtons.forEach((btn) => btn.addEventListener('click', () => this.selectLanguage(btn)));
        this.photoInput.addEventListener('change', this.updatePhotoPreview.bind(this));

        this.querySelectorAll('[data-next]').forEach((btn) =>
          btn.addEventListener('click', () => this.tryAdvance(btn))
        );
        this.querySelectorAll('[data-back]').forEach((btn) =>
          btn.addEventListener('click', () => this.goToStep(btn.dataset.back))
        );
        this.querySelectorAll('.js-review-goto').forEach((btn) =>
          btn.addEventListener('click', () => this.goToStep(btn.dataset.goto))
        );

        this.form.addEventListener('submit', this.onSubmit.bind(this));

        this.updateAgeDisplay();
      }

      onBirthdateChange() {
        const m = this.monthSelect.value;
        const d = this.daySelect.value;
        const y = this.yearSelect.value;
        if (!m || !d || !y) return;

        const birth = new Date(Number(y), Number(m) - 1, Number(d));
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        let next = new Date(today.getFullYear(), birth.getMonth(), birth.getDate());
        if (next < today) {
          next = new Date(today.getFullYear() + 1, birth.getMonth(), birth.getDate());
        }

        this.currentAge = next.getFullYear() - birth.getFullYear();
        this.updateAgeDisplay();

        this.celebrationDateInput.value = next.toISOString().slice(0, 10);
        this.birthdateValueInput.value = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
        this.celebrationCard.hidden = false;
      }

      updateAgeDisplay() {
        this.ageValueEl.textContent = this.currentAge;
        this.turnsValueInput.value = this.currentAge;
      }

      selectGender(btn) {
        this.genderButtons.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.genderValueInput.value = btn.dataset.value;
      }

      selectLanguage(btn) {
        this.languageButtons.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.languageValueInput.value = btn.dataset.value;
      }

      updatePhotoPreview() {
        const file = this.photoInput.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
          this.photoPreview.src = reader.result;
          this.photoPreview.hidden = false;
          this.dropzonePlaceholder.hidden = true;
        };
        reader.readAsDataURL(file);
      }

      validatePanel(panelName) {
        if (panelName === 'details') {
          if (!this.nameInput.value.trim()) return 'Please add the child’s name.';
          if (!this.monthSelect.value || !this.daySelect.value || !this.yearSelect.value) {
            return 'Please complete their birthdate.';
          }
          if (!this.celebrationDateInput.value) return 'Please choose a celebration date.';
          if (!this.genderValueInput.value) return 'Please select Boy or Girl.';
        }
        if (panelName === 'photo' && !this.photoInput.files[0]) {
          return 'Please add a photo.';
        }
        if (panelName === 'language' && !this.languageValueInput.value) {
          return 'Please select a language.';
        }
        return null;
      }

      tryAdvance(btn) {
        const currentPanel = btn.closest('.bv-wizard__panel').dataset.panel;
        const error = this.validatePanel(currentPanel);
        if (error) {
          this.showError(error);
          return;
        }
        this.hideError();
        this.goToStep(btn.dataset.next);
      }

      goToStep(stepName) {
        if (stepName === 'review') this.populateSummary();
        if (stepName === 'language') {
          const name = this.nameInput.value.trim() || 'Sofia';
          this.langNameEls.forEach((el) => (el.textContent = name));
        }
        this.panels.forEach((p) => {
          p.hidden = p.dataset.panel !== stepName;
        });

        const stepOrder = ['details', 'photo', 'language', 'complete'];
        const resolvedStepName = stepName === 'review' ? 'complete' : stepName;
        const currentIndex = stepOrder.indexOf(resolvedStepName);
        this.stepTabs.forEach((t) => {
          const tabName = t.dataset.stepTab;
          const isActive = tabName === stepName || t.dataset.stepTabAlias === stepName;
          const tabIndex = stepOrder.indexOf(tabName);
          t.classList.toggle('is-active', isActive);
          t.classList.toggle('is-complete', !isActive && tabIndex > -1 && tabIndex < currentIndex);
        });
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      formatDate(isoString) {
        if (!isoString) return '—';
        const [y, m, d] = isoString.split('-').map(Number);
        const date = new Date(y, m - 1, d);
        return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const day = result.getDay();
          if (day !== 0 && day !== 6) added += 1;
        }
        return result;
      }

      populateSummary() {
        const name = this.nameInput.value.trim() || 'Birthday Star';
        const isBoy = this.genderValueInput.value === 'Niño';
        /* ENG, no US: US es un pais, no un idioma. */
        const languageLabel = this.languageValueInput.value === 'Spanish' ? 'ESP Español' : 'ENG English';

        const uploadedPhoto = this.photoInput.files[0];
        if (uploadedPhoto) {
          const reader = new FileReader();
          reader.onload = () => {
            this.reviewAvatar.src = reader.result;
          };
          reader.readAsDataURL(uploadedPhoto);
        } else {
          this.reviewAvatar.src = this.reviewAvatar.dataset[isBoy ? 'boySrc' : 'girlSrc'];
        }
        this.reviewName.textContent = name;
        this.reviewAge.textContent = this.birthdateValueInput.value ? `Turning ${this.currentAge}` : 'Age not set';
        this.reviewLangBadge.textContent = this.languageValueInput.value ? languageLabel : '—';

        this.reviewNameField.textContent = this.nameInput.value.trim() || '—';
        this.reviewBirthdate.textContent = this.formatDate(this.birthdateValueInput.value);
        this.reviewCelebration.textContent = this.formatDate(this.celebrationDateInput.value);
        this.reviewLanguage.textContent = this.languageValueInput.value ? languageLabel : '—';
        this.reviewPhoto.textContent = this.photoInput.files[0] ? 'Uploaded' : '—';

        const deliveryDate = this.addBusinessDays(new Date(), 7);
        this.reviewDeliveryDate.textContent = deliveryDate.toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        });
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.toggleAttribute('aria-disabled', isLoading);
        this.submitButton.disabled = isLoading;
        if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
      }

      showError(message) {
        this.errorMessage.textContent = message;
        this.errorMessage.hidden = false;
        this.errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      hideError() {
        this.errorMessage.hidden = true;
      }

      async uploadPhoto() {
        const file = this.photoInput.files[0];
        if (!file) throw new Error('Please add a photo.');

        const formData = new FormData();
        formData.append('photo', file);

        const response = await fetch(this.dataset.uploadEndpoint, { method: 'POST', body: formData });
        const json = await response.json();
        if (!response.ok || !json.ok || !json.url) {
          throw new Error(json.error || 'Photo upload failed, please try again.');
        }
        return json.url;
      }

      async onSubmit(event) {
        event.preventDefault();
        this.hideError();

        this.setLoading(true);
        try {
          const photoUrl = await this.uploadPhoto();
          this.photoValueInput.value = photoUrl;

          const properties = {};
          this.form.querySelectorAll('[name^="properties["]').forEach((input) => {
            const match = input.name.match(/properties\[(.+)\]/);
            if (match && input.value) properties[match[1]] = input.value;
          });

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: this.dataset.variantId, quantity: 1, properties }],
            }),
          });
          const cartJson = await response.json();
          if (!response.ok) {
            const message =
              cartJson.description ||
              (typeof cartJson.errors === 'string' ? cartJson.errors : null) ||
              (cartJson.errors && Object.values(cartJson.errors).flat().join(' ')) ||
              'Could not add this product to your cart.';
            throw new Error(message);
          }

          this.goToStep('complete');
          setTimeout(() => {
            window.location.href = window.routes?.cart_url || '/cart';
          }, 1200);
        } catch (error) {
          this.showError(error.message);
          this.setLoading(false);
        }
      }
    }
  );
}
